import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DictionaryView, getDictionaryOptions } from '@/module/Author/Dictionary';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { dictionaryId } = Route.useParams();
  const { data: dictionary } = useSuspenseQuery(getDictionaryOptions(dictionaryId));

  return <DictionaryView dictionary={dictionary} />;
}
